import { useWindowSize } from 'react-use'

import { useAuth } from '../../Provider/AuthProvider'
import { usePageTitle } from '../../Services/MenuConfig'
import { cap } from '../../State'
import { translations } from '../../translations'
import { VersionInfo } from '../Versioning'
import siapDARK from './images/siap_dark.png'
import siapLIGHT from './images/siap_light.png'
import LanguageSelector from './LanguageSelector'
import { HamburgerMenu } from './SlidingMenu'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Toggle tema giorno/notte: thumb scorrevole con dentro l'icona del tema
 * attivo (sole se light, luna se dark). Sostituisce PrimeReact InputSwitch
 * perché la richiesta è avere le icone *dentro* il pulsante.
 * @param {Object} props
 * @param {boolean} props.darkMode
 * @param {Function} props.onChange
 */
const ThemeToggle = ({ darkMode, onChange }) => (
  <button
    type="button"
    className={`nora-theme-switch${darkMode ? ' is-dark' : ''}`}
    onClick={() => onChange(!darkMode)}
    aria-label={darkMode ? t.switchToLight : t.switchToDark}
    aria-pressed={darkMode}
  >
    <span className="nora-theme-switch__thumb">
      <i className={`pi ${darkMode ? 'pi-moon' : 'pi-sun'}`} aria-hidden="true" />
    </span>
  </button>
)

export const TopMenu = ({ onToggleSidebar }) => {
  const { width } = useWindowSize()
  const { user: userObj = {} } = useAuth()
  const { user = {} } = userObj || {}
  const { user: { society } = {} } = user || {}
  const title = usePageTitle()
  const [darkMode, setDarkMode] = cap.darkMode.useState()
  const [language, setLanguage] = cap.language.useState()

  const handleLanguageChange = (language) => {
    setLanguage(language)
    window.location.reload()
  }

  const showSociety = width > 1240 && typeof society === 'string' && society.trim().length > 0

  return (
    <div className="nora-topbar">
      <div className="nora-topbar__left">
        <HamburgerMenu onToggle={onToggleSidebar} />
        <div className="nora-page-title">{title}</div>
      </div>
      <div className="nora-topbar__right">
        <LanguageSelector value={language} onChange={handleLanguageChange} />
        <ThemeToggle darkMode={darkMode} onChange={setDarkMode} />
        {showSociety && <span className="nora-society">{society}</span>}
        <img src={darkMode ? siapLIGHT : siapDARK} style={{ maxHeight: 36 }} alt="SIAP" />
        <VersionInfo />
      </div>
    </div>
  )
}
